import * as React from "react";
import * as moment from "moment";
import { api, user, shared, dataList } from "src/services/api";
import { classNames } from "src/services/theme";
import { FormState, Form, Fieldset, bindToAPI, resetState, _ } from "src/services/form";
import { Formatters, Calendario, Modal, Tooltip } from "src/components/ui";
import OrdineCheckout from "./OrdineCheckout";

export interface Props {
    tipo: "ADSP" | "ADWORDS";
    costo?: number;
    adsp: any[];
    onCarrello?: Function;
    onAdsp?: Function;
    onAdwords?: Function;
}

export interface State {
    phase: string;
    choose?: any;
    province?: any[];
    items: any;
    slots: any;
    pages: any;
    adsp: any;
    others: any;
    date: moment.Moment;
    offerta?: string;
    loading: string | null;
}

export class Visor<T extends Props, S extends State> extends React.Component<T, S> {
    constructor(props) {
        super(props);
        
        // set state
        this.state = {
          phase: "INDEX",
          province: [],
          items: {},
          slots: {},
          pages: {},
          adsp: props.adsp.filter( v => v.tipo === props.tipo ),
          others: props.adsp.filter( v => v.tipo !== props.tipo ),
          date: moment(),
          loading: null
        } as any;
    }
    
    componentDidMount() {
        const { date, adsp } = this.state;
        const { tipo } = this.props;
        // collect province
        let province;
        if (tipo === "ADSP") {
          if (adsp) {
            province = adsp.reduce( (p, c) => {
              if (!p.filter( p => p.id === c.id_provincia ).length) {
                  p.push( shared.provincia.filter( p => p.id === c.id_provincia )[0] );
              }
              return p;
            }, []);
            province.forEach( p => {
              this.addProvincia( {
                id_provincia: p.id
              });
            });
          }
          if (province.length === 0) {
            this.setState({
              choose: true
            });
          }
        }
        if (tipo === "ADWORDS") {
          this.addProvincia( {
            id_provincia: shared.provincia[0].id
          });
        }
    }
    
    getLocalVal( key ) {}

    addProvincia( values ) {
        const { date } = this.state;
        const { id_provincia } = values;
        const provincia = shared.provincia.filter( p => p.id === id_provincia )[0];
        let province = this.state.province || [];
        province!.push( provincia );
        let pages = this.state.pages;
        pages[ id_provincia ] = 0;
        this.setState({
          province,
          pages
        });
        
        this.changeMonth({
          id_provincia: provincia.id,
          date: date
        })
        this.refreshProvincia( {
          provincia
        });
    }
    
    async refreshProvincia( { provincia } ) {
        const { tipo } = this.props;
        this.setState({
          loading: provincia.id
        });
        const { province, items } = this.state;
        const args = {
          recipient_id: this.getLocalVal('id'),
          recipient_type: this.getLocalVal('type'),
          tipo,
          carrello: true,
          ipp: 100000000000,
        } as any;
        if (tipo === "ADSP") {
          args.id_provincia = provincia.id;
        }
        const _items = await api({
            url: "ads/adsp",
            params: args
        });
        let newItems = items;
        newItems[provincia.id] = _items.map(i=>({
          ...i,
          DataInizio: moment(i.DataInizio),
          DataFine: moment(i.DataFine)
        }));
        this.setState({
          items: newItems,
          loading: null
        });
    }
  
    async selectSlot( provincia, slot ) {
        if ((slot.status !== "free") && (slot.status !== "cart")) {
          return;
        }
        this.setState({
          loading: provincia.id
        });
        const { date } = this.state;
        const { tipo } = this.props;
        const args = {
          recipient_id: this.getLocalVal('id'),
          recipient_type: this.getLocalVal('type'),
          tipo,
          DataInizio: slot.start.toISOString(true),
          DataFine: slot.end.toISOString(true)
        } as any;
        if (tipo === "ADSP") {
          args.id_provincia = provincia.id;
        }
        
        let toReload = false;
        // if free, select it (create)
        if (slot.status === "free") {
          const result = await api({
            method: "post",
            url: "ads/adsp",
            //appActions: true,
            params: args
          });
          toReload = true;
        }
        // if cart, unselect it (purge)
        if (slot.status === "cart") {
          const result = await api({
            method: "post",
            url: "ads/adsp/purge",
            //appActions: true,
            params: args
          });
          toReload = true;
        }
        
        if (toReload) { // if somethings happened
          this.changeMonth({
            id_provincia: provincia.id,
            date: date
          });
          this.refreshProvincia({
            provincia
          })
        }
    }
  
    async destroyItem( provincia, item ) {
        this.setState({
          loading: provincia.id
        });
        const { date } = this.state;
        const result = await api({
          method: "delete",
          url: `ads/adsp/${item.id}`
        });
        this.changeMonth({
          id_provincia: provincia.id,
          date: date
        });
        this.refreshProvincia({
          provincia
        })
    }
  
    async destroyAll( provincia ) {
        this.setState({
          loading: provincia.id
        });
        const { date, province } = this.state;
        const { tipo } = this.props;
        const args = {
          recipient_id: this.getLocalVal('id'),
          recipient_type: this.getLocalVal('type'),
          tipo
        } as any;
        if (tipo === "ADSP") {
          args.id_provincia = provincia.id;
          const newProvince = province!.filter( p => ( p.id !== provincia.id ));
          this.setState({
            province: newProvince
          })
        }
        const result = await api({
          method: "post",
          url: "ads/adsp/purge",
          //appActions: true,
          params: args
        });
        this.changeMonth({
          id_provincia: provincia.id,
          date: date
        });
        this.refreshProvincia({
          provincia
        })
    }
  
    async changeMonth( { id_provincia, date } ) {
        this.setState({
          loading: id_provincia
        });
        const { tipo } = this.props;
        const { province, slots } = this.state;
        const args = {
          recipient_id: this.getLocalVal('id'),
          recipient_type: this.getLocalVal('type'),
          id_provincia: id_provincia,
          tipo,
          start: date.clone().startOf('month').format(),
          end: date.clone().endOf('month').format()
        };
        const items = await api({
          url: "../profile/ecommerce/ads/adsp/calendario.json",
          params: args
        });
        
        let newSlots = slots;
        newSlots[id_provincia] = items.map(i=>({
          ...i,
          start: moment(i.start),
          end: moment(i.end)
        }));
        
        this.setState({
          slots: newSlots,
          date,
          loading: null
        })
    }
  
    changeProvinciaPage( id_provincia, page ) {
        this.setState({
          pages: {
            ...this.state.pages as any,
            [id_provincia]: page
          }
        })
    }
  
    checkOfferta() {
        const { tipo } = this.props;
        const { others } = this.state;
        if (others.filter(v => { return !v.expired }).length) {
          this.setState({
            offerta: tipo
          });
        } else {
          this.goToCarrello();
        }
    }
  
    goToCarrello() {
        const { onCarrello } = this.props;
        if (onCarrello) {
          onCarrello();
        }
    }
  
    render() {
        const { tipo, costo = 0, adsp, onAdsp, onAdwords } = this.props;
        const { phase, choose, province, items, slots, pages, offerta, loading } = this.state;
        return (
          <div className="ecommerce_VisorScuola">
            <div className="ecommerce_Cover">
              <div>
                <div className="container">
                  <h3><strong>Visor</strong> for Business</h3>
                  <p>Con i piani Visor For Business sarai in cima nel nostro mondo.<br />
                  In cima tra i leader.</p>
                </div>
              </div>
            </div>
            <div className="container">
            <section className="info">
              <span />
              <span>
                Stai acquistando servizi <em>Visor for Business</em> per:
                <span> {this.getLocalVal('label')} </span>
              </span>
            </section>
            <section className="choices">
              <div onClick={() => { if (onAdsp) { onAdsp({id: this.getLocalVal('id')}); } }}>
                <button className={classNames("btn-block adsp", tipo === "ADSP" ? "active" : null)}><span>Visor Vetrina</span></button>
                <div>
                  <span className={classNames("ui-radio", tipo === "ADSP" ? "active" : null)} />
                </div>
              </div>
              <div onClick={() => { if (onAdwords) { onAdwords({id: this.getLocalVal('id')}); } }}>
                <button className={classNames("btn-block adwords", tipo === "ADWORDS" ? "active" : null)}><span>AD Words</span></button>
                <div>
                  <span className={classNames("ui-radio", tipo === "ADWORDS" ? "active" : null)} />
                </div>
              </div>
            </section>
            {offerta === "ADSP" &&
            <Modal
              open={true}
              backdrop={true}
              icon={!user.thumb ? "person_female_filled" : null}
              iconImg={user.thumb || null}
              className="ecommerce_VisorScuola_offer_adwords ecommerce_AcquistiScuola_bigheader"
              onClose={() => this.setState({offerta: undefined})}
            >
              <header>
                <h2>{user.nome}</h2>
                <p>
                Pensiamo che potrebbero interessarti degli spazi <em>Visor AD Words</em> per questa sede.
                </p>
                <p>
                Vuoi acquistarli ora?
                </p>
              </header>
              <section>
                <div>
                  <a className="btn sm frameless btn-block" onClick={() => { if (onAdwords) { onAdwords({id: this.getLocalVal('id')}); } }}><span>Voglio acquistare</span></a>
                  <a onClick={() => this.goToCarrello()}>No grazie, preferisco pensarci</a>
                </div>
              </section>
            </Modal>
            }
            {offerta === "ADWORDS" &&
            <Modal
              open={true}
              backdrop={true}
              icon={!user.thumb ? "person_female_filled" : null}
              iconImg={user.thumb || null}
              className="ecommerce_VisorScuola_offer_adsp ecommerce_AcquistiScuola_bigheader"
              onClose={() => this.setState({offerta: undefined})}
            >
              <header>
                <h2>{user.nome}</h2>
                <p>
                Pensiamo che potrebbero interessarti degli spazi <em>Visor Vetrina</em> per questa sede.
                </p>
                <p>
                Vuoi acquistarli ora?
                </p>
              </header>
              <section>
                <div>
                  <a className="btn sm frameless btn-block" onClick={() => { if (onAdsp) { onAdsp({id: this.getLocalVal('id')}); } }}><span>Voglio acquistare</span></a>
                  <a onClick={() => this.goToCarrello()}>No grazie, preferisco pensarci</a>
                </div>
              </section>
            </Modal>
            }
            {choose &&
            <Modal
              open={true}
              backdrop={true}
              icon="horn"
              className="ecommerce_VisorScuola_choose"
              onClose={() => this.setState({choose: null})}
            >
              <header>
                {province!.length === 0 &&
                <h3> {this.getLocalVal('choose_first')} </h3>
                }
                {province!.length > 0 &&
                <h2>Aggiungi una nuova provincia</h2>
                }
              </header>
              <div>
                <Form onSubmit={values => { this.addProvincia(values); this.setState({choose: null}); } } render={(form) => {
                  return (
                  <form onSubmit={form.submitForm}>
                    <div className="row">
                      <div className="col-xs-8">
                        <Fieldset
                            fieldsParams={{
                                'id_provincia': { type: 'select', options: _.pluck(shared.provincia, "provincia") },
                            }}
                        />
                      </div>
                      <div className="col-xs-4">
                        <button type="submit" className="md btn-block main2"><span>Continua</span></button>
                      </div>
                    </div>
                  </form>
                  )
                  }} />
              </div>
            </Modal>
            }
            {province!.map( (provincia, i) => {
              let __slots;
              if (slots[ provincia.id ]) {
                const _slots = slots[ provincia.id ];
                __slots = _slots.map( (i,k) => {
                  const s = { marginLeft: `${100/7*i.offset}%` };
                  return {
                    ...i,
                    component: i.status === 'unavailable' ? null : (
                      <article key={k} onClick={() => this.selectSlot(provincia, i)} className={i.status}>
                        <div className="week-selector">
                            <span><span className="icon-check" /></span>
                        </div>
                        <div className="price" style={s} title={i.note}>
                          {i.price}
                        </div>
                        <div className="availability" dangerouslySetInnerHTML={{__html: i.availability}} style={s} />
                      </article>
                    )
                  }
                });
              }
              
              const itemsProv = items[ provincia.id ]
              let months, _items, page, chunks, itemsPage, total;
              if (itemsProv) {
                // paginate
                page = pages[ provincia.id ];
                chunks = dataList.chunk( itemsProv, 10 );
                itemsPage = chunks.length ? chunks[ page ] : [] as any;
              
                // divide in months
                _items = itemsPage.reduce( (p,i,k) => {
                  const key = i.DataInizio.format('YYYYMM');
                  if (!p[key]) { p[key] = []; }
                  p[key].push( i );
                  return p;
                }, {});
                months = Object.keys(_items).sort();
                
                // find total
                total = itemsProv.reduce( (p,i,k) => {
                  console.log('p', p, i.prezzo)
                  return p+i.prezzo;
                }, 0);
              }
              if (!months) {
                months = [];
              }
              
              return (
              <section className={`provincia ${loading === provincia.id ? 'loading' : ''}`} key={i}>
                <div className="cal">
                  {tipo === "ADSP" &&
                  <h4>Posizione homepage per la provincia di <span>{provincia.provincia}</span> </h4>
                  }
                  {tipo === "ADWORDS" &&
                  <h4>In cima ai risultati</h4>
                  }
                  <Calendario
                    slots={__slots || []}
                    onChangeMonth={(date) => this.changeMonth({id_provincia: provincia.id, date})}
                  />
                </div>
                <div className="list">
                  {months.length > 0 &&
                  <>
                  <div className="remove-all" onClick={() => this.destroyAll(provincia)}>
                      <span className="icon-close" />
                  </div>
                  <article>
                    {tipo === "ADSP" &&
                    <header>La tua prenotazione a: <strong>{provincia.provincia}</strong></header>
                    }
                    <div className="months">
                    {months.map( month => {
                      const __items = _items[month];
                      return (
                        <div className="month" key={month}>
                          <strong>{__items[0].DataInizio.format('MMMM YYYY')}</strong>
                          <table>
                            <thead>
                              <tr>
                                <th>Dal</th>
                                <th>Al</th>
                                <th />
                              </tr>
                            </thead>
                            <tbody>
                              {__items.map( (i,k) => (
                              <tr key={k}>
                                <td>{i.DataInizio.format('D/M/YYYY')}</td>
                                <td>{i.DataFine.format('D/M/YYYY')}</td>
                                <td>
                                  <Tooltip title="Elimina">
                                  <span className="icon-remove" onClick={() => this.destroyItem(provincia, i)} />
                                  </Tooltip>
                                </td>
                              </tr> 
                              ))}
                            </tbody>
                          </table>
                        </div>
                      );
                    } )}
                    </div>
                    {chunks && chunks.length > 0 &&
                    <nav>
                      <span className={`icon-prev ${(page > 0) ? 'active' : ''}`} onClick={() => { if (page > 0) this.changeProvinciaPage(provincia.id, page-1) } } />
                      <span className={`icon-next ${(page !== chunks.length-1) ? 'active' : ''}`} onClick={() => { if (page !== chunks.length-1) this.changeProvinciaPage(provincia.id, page+1) } } />
                    </nav>
                    }
                  <div className="total">
                    <span>Crediti</span>
                    <strong>{total}</strong>
                  </div>
                  <div className="total-value">
                    <span>Valore</span>
                    <strong>{Formatters.Price({val: total * costo})}</strong>
                  </div>
                  <div className="total-weeks">
                    <span>Settimane</span>
                    <strong>{itemsProv.length}</strong>
                  </div>
                  </article>
                  </>
                  }
                  {months.length === 0 &&
                  <article className="none">
                    Aggiungi settimane dal calendario.
                  </article>
                  }
                </div>
              </section>
              )
            })}
            <footer className="toolbar">
              <button type="button" className="wicon pre frameless"><span><span className="icon-back" /><em>Indietro</em></span></button>
              <span>
              {tipo === "ADSP" &&
              <a className="add-provincia" onClick={() => this.setState({choose: true}) }><span className="icon-add" /><span>Prenota in una nuova provincia</span></a>
              }
              </span>
              <span>
              {province!.length > 0 &&
              <button type="button" className="md wicon post main3" onClick={() => this.checkOfferta() }><span><em>Acquista</em><span className="icon-buy_upgrade" /></span></button>
              }
              </span>
            </footer>
            
            </div>
          </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ecommerce/Visor.tsx